import rulesTemplate from './rules.html';

export default angular
  .module('main.locations.edit.tabs.rules', [])

  .directive('editLocationRulesTab', () => {
    return {
      restrict: 'E',
      template: rulesTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $state,
                   $filter,
                   utils,
                   ToastsService,
                   EditLocationDataProvider) => {
        $scope.dataProvider = EditLocationDataProvider.instance;
        const $t = $filter('translate');

        angular.extend($scope, {
          onViewRuleButtonClick: onViewRuleButtonClick,
          onDeleteRuleButtonClick: onDeleteRuleButtonClick
        });

        init();

        function init() {
          $scope.loading = true;
          $q.all([
            $scope.dataProvider.locationIdResource.init(),
            $scope.dataProvider.locationRulesResource.init()
          ])
            .then(() => {
              $scope.searchVal = $scope.dataProvider.rulesTabSearchValue || '';
              $scope.dataProvider.rulesTabSearchValue = undefined;
              initViewModel();
              $scope.loading = false;
            }, (err) => {
              // utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initViewModel() {
          $scope.rules = $scope.dataProvider.locationRulesResource.value;
          $scope.rulesCount = $scope.rules.length;
        }

        function onViewRuleButtonClick(rule) {
          if (!rule || $scope.loading) {
            return;
          }

          utils.setStorageItem('view-rule', rule);
          $state.go('main.rules.view', {
            from: 'location',
            locationId: $scope.dataProvider.locationIdResource.value,
            ruleId: rule.id
          });
          $rootScope.$emit('refreshChooseMenuEvent', 'rules');
        }

        function onDeleteRuleButtonClick(rule) {
          if (!rule || $scope.loading) {
            return;
          }

          $('#remove-rule-dialog').modal({
            closable: true,
            detachable: true,
            onApprove: function() {
              $('#remove-rule-dialog').modal('hide');

              $scope.loading = true;
              return $scope.dataProvider.removeLocationRule(rule)
                .then(() => {
                  $('#remove-rule-dialog').modal('hide');
                  ToastsService.success($t('rules.delete.success'), $t('rules.delete.successDesc'));
                  initViewModel();
                  $scope.loading = false;
                }, (err) => {
                  $('#remove-rule-dialog').modal('hide');
                  utils.handleApiError(err);
                  $scope.loading = false;
                });
            }
          }).modal('show');
        }
      }
    };
  })
  .name;
